import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarMapaFinanceiro(api, parametros) {
    parametros.operacao = 'buscarMapaFinanceiro';

    let retorno = {};

    await api.santriGET('/rest/mapaFinanceiro', parametros, 60, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RMapaFinanceiro.js